<template>
  <div class="com-anm22-app-inner-wrapper">
    <!-- Employee status modal -->
    <wg-modal :simple="true" :width="'300px'" v-if="showStatusModal" @closeModal="showStatusModal = false">
      <div slot="body" class="wg-row">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Select order status', 'Seleziona stato dell\'ordine') }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div
            v-for="(status,index) in $anm22.tableClasses.foodOrderStatus().getAll()"
            :key="'s-'+index"
            class="wg-row com-anm22-app-text-l status-change-selectable"
            :style="{color: getStatusLabelStyle(status.typeClass)}"
            @click="changeStatus(status)"
        >{{ status[lang] }}</div>
      </div>
    </wg-modal>
    <!-- Modale pagamento online -->
    <wg-modal v-if="showCardModal" :width="'500px'" @closeModal="showCardModal = false;">
      <div slot="header" class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, 'Pay online', 'Pagamento online') }}
      </div>
      <div slot="body" class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:center;">
        <vue-simple-spinner v-show="cardLoading" size="medium" :line-fg-color="appColor"></vue-simple-spinner>
        <div class="wg-row" style="justify-content:center;" v-show="!cardLoading">
          <template v-if="paymentError">
            <template v-if="paymentError === 1">
              <div class="com-anm22-app-text-l" style="color:red;">
                {{ $anm22.strLang(lang, 'There was an error during payment processing.', 'Si è verificato un errore durante il pagamento.') }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="com-anm22-app-text-l" style="color:red;">
                {{ $anm22.strLang(lang, 'No amount has been charged. Please, try again.', 'Nessun addebito effettuato. Si prega di provare nuovamente.') }}
              </div>
            </template>
            <template v-else>
              <div class="com-anm22-app-text-l" style="color:red;">
                {{ $anm22.strLang(lang, 'Reload the page to confirm the payment.', 'Ricaricare la pagina per confermare il pagamento.') }}
              </div>
            </template>
            <div class="vertical-height-div" style="height:10px;"></div>
          </template>
          <div class="wg-row" style="justify-content:center;" v-show="!paying">
            <!-- STRIPE -->
            <template v-if="license.stripeTest || license.stripeAccount">
              <div class="wg-row" style="justify-content:center;margin:0 20px 10px 20px;">
                <div id="stripe-payment-request-button" style="width:100%;"></div>
              </div>
              <form id="stripe-card-form" style="width:100%;margin:0 20px 10px 20px;">
                <!-- Credit card -->
                <label for="stripe-card" style="font-size:14px;color:#90A4AE;">
                  {{ $anm22.strLang(lang, 'Use credit or debit card', 'Carta di debito o credito') }}
                </label>
                <div class="vertical-height-div" style="height:5px;"></div>
                <div id="stripe-card"></div>
                <div class="vertical-height-div" style="height:5px;"></div>
                <div id="stripe-card-errors" role="alert"></div>
                <div class="vertical-height-div" style="height:5px;"></div>
                <button id="submit" class="stripe-submit" style="position:relative;">
                  {{ $anm22.strLang(lang, 'Pay with card', 'Paga con carta') }}
                </button>
                <div class="vertical-height-div" style="height:10px;"></div>
                <div class="wg-row" style="justify-content:center;">
                  <img :src="$anm22.icons.getWorldIcon('stripePoweredBy')" style="height:26px;width:119px;">
                </div>
              </form>
            </template>
            <div v-if="license.stripeAccount && license.paypalMerchantId" class="com-anm22-app-horizontal-line-light"></div>
            <!-- PAYPAL -->
            <div v-if="license.paypalMerchantId" id="paypal-buttons-div" style="margin:10px 20px 0 20px;width:100%;"></div>
          </div>
          <div class="wg-row" style="justify-content:center;" v-show="paying">
            <div class="vertical-height-div" style="height:10px;"></div>
            <vue-simple-spinner size="medium" :line-fg-color="appColor"></vue-simple-spinner>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="com-anm22-app-text-xl" style="text-align:center;">
              {{ $anm22.strLang(lang, 'Processing payment...', 'Pagamento in corso...') }}
            </div>
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="com-anm22-app-text-xl" style="text-align:center;">
              {{ $anm22.strLang(lang, 'This may take some time to complete. Please wait.', 'Questa operazione può impiegare alcuni minuti.') }}
            </div>
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- Modale YB -->
    <wg-modal v-if="showYbModal" :width="windowWidth > 700 ? '700px' : '90%'" @closeModal="showYbModal = false;">
      <div slot="header" class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, 'Pay with Spiagge.it account', 'Paga con registrazione Spiagge.it') }}
      </div>
      <div slot="body" class="wg-row" style="justify-content:center;">
        <template v-if="ybMode === 'select'">
          <div class="wg-row" style="justify-content:center;">
            <div class="com-anm22-app-text-xxl">
              {{ $anm22.strLang(lang, 'Choose the account to charge', 'Scegliere il conto su cui addebitare l\'importo') }}  
            </div>
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row" style="justify-content:center;">
            <yb-reg-card 
                v-for="(reg,index) in ybRegs.regs"
                :key="'reg-'+index" 
                :reg="reg"
                :timezone="timezone"
                :selected="selectedReg && selectedReg.id === reg.id"
                @select-reg="selectYbReg(reg)"
            ></yb-reg-card>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <input 
              :disabled="!selectedReg"
              type="button" 
              :value="$anm22.strLang(lang, 'Confirm', 'Conferma')"
              @click="sendToYB"
          >
        </template>
        <!-- Mostro un caricamento per il pagamento -->
        <div v-else class="wg-row" style="align-items:center;justify-content:center;margin-top:20px;">
          <template v-if="selectedReg">
            <yb-reg-card 
                :reg="selectedReg"
                :selected="true"
                :timezone="timezone"
            ></yb-reg-card>
            <div class="vertical-height-div" style="height:20px;"></div>
          </template>
          <vue-simple-spinner size="medium" :line-fg-color="appColor"></vue-simple-spinner>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Processing payment...', 'Pagamento in corso...') }}
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- Modale ANM22 Pay -->
    <wg-modal v-if="showPayModal" :width="windowWidth > 700 ? '700px' : '90%'" @closeModal="showPayModal = false;">
      <div slot="header" class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, 'Pay with your card', 'Paga con la tua tessera') }}
      </div>
      <div slot="body" class="wg-row" style="justify-content:center;">
        <template v-if="!paying">
          <div class="wg-row" style="justify-content:center;">
            <div class="com-anm22-app-text-xxl">
              {{ $anm22.strLang(lang, 'Choose the card to use', 'Scegliere la tessera da usare') }}  
            </div>
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row" style="justify-content:center;">
            <anm-22-pay-card 
                v-for="(card) in payCards"
                :key="'pay-card-'+card.idWorldCard"
                @click.native="selectPayCard(card)"
                :card="card"
                :selected="selectedPayCard === card.idWorldCard"
                :timezone="timezone"
                :view="'customer'"
            ></anm-22-pay-card>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <input 
              :disabled="!selectedPayCard"
              type="button" 
              :value="$anm22.strLang(lang, 'Confirm', 'Conferma')"
              @click="sendToPay"
          >
        </template>
        <!-- Mostro un caricamento per il pagamento -->
        <div v-else class="wg-row" style="align-items:center;justify-content:center;margin-top:20px;">
          <template v-if="paying">
            <anm-22-pay-card 
                :card="selectedPayCard"
                :timezone="timezone"
                :view="'customer'"
            ></anm-22-pay-card>
            <div class="vertical-height-div" style="height:20px;"></div>
          </template>
          <vue-simple-spinner size="medium" :line-fg-color="appColor"></vue-simple-spinner>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Processing payment...', 'Pagamento in corso...') }}
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- Main page -->
    <div v-if="loading" class="wg-row" style="align-items:center;justify-content:center;margin-top:20px;">
      <vue-simple-spinner size="medium" :line-fg-color="appColor"></vue-simple-spinner>
    </div>
    <template v-if="!loading">
      <!-- Titolo e stato -->
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-md-8">
          <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
            <div style="font-size:24px;">
              {{ 
                  (table ? (table.name + ' ' + order.tableAlias + ' - ') : '') 
                  + $anm22.strLang(lang, 'Order ', 'Ordine ')
                  + order.number
              }}
            </div>
            <div v-if="order.payed" class="payed-label">
              {{ $anm22.strLang(lang, 'Payed', 'Pagato') }}
            </div>
          </div>
        </div>
        <div class="vertical-height-div wg-md-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-md-4">
          <div 
              class="wg-row"
              :style="{justifyContent: windowWidth < 992 ? 'flex-start' : 'flex-end'}"
          >
            <div 
                :class="[employment ? 'status-selectable' : '']"
                :style="{fontSize: windowWidth < 992 ? '16px' : '24px', color: statusColor}"
                @click="employment ? showStatusModal = true : ''"
            >
              {{ $anm22.tableClasses.foodOrderStatus().getById(order.status)[lang] }}
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <!-- Cliente -->
      <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
        <div style="width:20px;height:20px;margin-right:5px;">
          <world-object-icon
              :type="'user'" 
              :obj="customer"
              :isImg="true">
          </world-object-icon>
        </div>
        <div class="com-anm22-app-text-xl">
          {{ customer.name + ' ' + customer.surname }}
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <!-- Data e ora -->
      <div class="wg-row com-anm22-app-text-xl">
        {{ $moment.tz(order.orderDate, 'X', timezone).format('DD-MM-YYYY HH:mm') }}
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <div class="wg-row">
        <!-- Tasti per il pagamento -->
        <template v-if="(!employment || employment.permission === 1) && !order.payed && (order.paymentMethod === 3 || order.paymentMethod === 7 || order.paymentMethod === 9)">
          <div v-if="order.isPaying" class="wg-row com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, 'Processing payment', 'Elaborazione del pagamento') }}
          </div>
          <input 
              v-else
              type="button" 
              :value="$anm22.strLang(lang, 'Pay now', 'Paga subito')"
              @click="openPaymentModal"
          >
          <div class="horizontal-height-div" style="width:10px;"></div>
        </template>
        <button v-if="employment" @click="openOrderEmployee">
          <img :src="$anm22.icons.getWorldIcon('menuRegister')">
          <div>
            {{ $anm22.strLang(lang, 'Open register', 'Apri cassa') }}
          </div>
        </button>
      </div>
      <div class="vertical-height-div" style="height:30px"></div>
      <w-g-list
          v-if="elements.length > 0"
          :loading="loading"
          :sorting="false"
          :keyField="'id'"
          :headerItems="headerItems"
          :itemsToDisplay="tableItems"
      >
        <template v-slot:default="{ element }">
          <div class="wg-row item-row">
            <div class="wg-col wg-xs-5 wg-sm-7">
              <div class="wg-row com-anm22-app-text-l">
                {{ element.name }}
              </div>
            </div>
            <div class="wg-col wg-xs-5 wg-sm-3">
              <div class="wg-row com-anm22-app-text-l" style="justify-content:flex-end;">
                {{ element.unitPrice.toFixed(2) + ' &euro;' }}
              </div>
            </div>
            <div class="wg-col wg-xs-2">
              <div class="wg-row com-anm22-app-text-l" style="justify-content:flex-end;">
                {{ element.quantity || '' }}
              </div>
            </div>
          </div>
        </template>
      </w-g-list>
      <template v-if="order.deliveryPrice">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          <div class="wg-col wg-xs-9">
            <div class="display-flex" style="justify-content:flex-end;">
              {{ $anm22.strLang(lang, 'Delivery cost', 'Costo di consegna') }}
            </div>
          </div>
          <div class="wg-col wg-xs-3">
            <div class="display-flex" style="justify-content:flex-end;">
              {{ order.deliveryPrice.toFixed(2) + ' &euro;' }}
            </div>
          </div>
        </div>
      </template>
      <template v-if="discount">
        <div class="vertical-height-div" style="height:30px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          <div class="wg-col wg-xs-9">
            <div class="display-flex" style="justify-content:flex-end;">
              {{ $anm22.strLang(lang, 'Discount', 'Sconto') }}
            </div>
          </div>
          <div class="wg-col wg-xs-3">
            <div class="display-flex" style="justify-content:flex-end;">
              {{ discount.toFixed(2) + ' &euro;' }}
            </div>
          </div>
        </div>
      </template>
      <template v-if="surcharge">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          <div class="wg-col wg-xs-9">
            <div class="display-flex" style="justify-content:flex-end;">
              {{ $anm22.strLang(lang, 'Service cost', 'Costo servizio') }}
            </div>
          </div>
          <div class="wg-col wg-xs-3">
            <div class="display-flex" style="justify-content:flex-end;">
              {{ surcharge.toFixed(2) + ' &euro;' }}
            </div>
          </div>
        </div>
      </template>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row com-anm22-app-text-l">
        <div class="wg-col wg-xs-9">
          <div class="display-flex" style="justify-content:flex-end;">
            {{ $anm22.strLang(lang, 'VAT', 'IVA') }}
          </div>
        </div>
        <div class="wg-col wg-xs-3">
          <div class="display-flex" style="justify-content:flex-end;">
            {{ totalVat.toFixed(2) + ' &euro;' }}
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row com-anm22-app-text-l">
        <div class="wg-col wg-xs-9">
          <div class="display-flex" style="justify-content:flex-end;">
            {{ $anm22.strLang(lang, 'Total', 'Totale') }}
          </div>
        </div>
        <div class="wg-col wg-xs-3">
          <div class="display-flex" style="justify-content:flex-end;">
            {{ totalOrder.toFixed(2) + ' &euro;' }}
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:30px;"></div>
      <div class="wg-row com-anm22-app-text-l">
        {{ $anm22.strLang(lang, 'Notes: ', 'Note: ') + this.order.notes }}
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <div class="wg-row com-anm22-app-text-l">
        {{ 
          $anm22.strLang(lang, 'Payment method: ', 'Metodo di pagamento: ') 
            + this.$anm22.tableClasses.worldPaymentModeType().getById(order.paymentMethod)[lang]
        }}
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <div class="wg-row com-anm22-app-text-l">
        {{ $anm22.strLang(lang, 'Delivery method: ', 'Metodo di consegna: ') 
            + this.$anm22.tableClasses.worldDeliveryType().getById(order.deliveryType)[lang] }}
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <div class="wg-row com-anm22-app-text-l">
        {{ $anm22.strLang(lang, 'Delivery ETA: ', 'Tempo stimato per la consegna: ') 
            + (this.order.estimatedTime ? (this.order.estimatedTime + ' min') : $anm22.strLang(lang, 'Unknown', 'Sconosciuto'))}}
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <div class="wg-row com-anm22-app-text-l">
        {{ $anm22.strLang(lang, 'Chosen delivery time: ', 'Orario di consegna selezionato: ')
           + $moment.tz((order.deliveryTime ? order.deliveryTime : order.orderDate), 'X', timezone).format('DD-MM-YYYY HH:mm') }}
      </div>
      <template v-if="order.deliveryType === 1 || order.deliveryType === 2">
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Delivery at: ', 'Consegna presso: ') 
              + order.beachUmbrella + ' - ' + $store.getters['works/get'](order.beach).name}}
        </div>
      </template>
      <template v-if="order.deliveryType === 7">
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Delivery at: ', 'Consegna presso: ') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ order.deliveryData.name }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ order.deliveryData.street + ' ' + order.deliveryData.number }}
        </div>
        <template v-if="order.deliveryData.line2">
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row com-anm22-app-text-l">
            {{ order.deliveryData.line2 }}
          </div>
        </template>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ order.deliveryData.zip + ' ' + order.deliveryData.city + ' ' + order.deliveryData.state}}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ $anm22.tableClasses.worldCountry().getById(order.deliveryData.country)[lang]}}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ order.deliveryData.phone}}
        </div>
      </template>
      <template v-if="order.deliveryType === 9">
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Delivery at: ', 'Consegna presso: ') 
              + order.pickUpPoint[lang] }}
        </div>
      </template>
      <template v-if="order.deliveryType === 10">
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Delivery at Bungalow: ', 'Consegna presso Bungalow: ') }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ order.deliveryData.name }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ order.deliveryData.street + ' ' + order.deliveryData.number }}
        </div>
        <div class="vertical-height-div" style="height:5px;"></div>
        <div class="wg-row com-anm22-app-text-l">
          {{ order.deliveryData.phone}}
        </div>
      </template>
      <template v-if="order.deliveryData.notes">
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row com-anm22-app-text-l">
            {{ $anm22.strLang(lang, 'Delivery notes: ', 'Note consegna: ') + order.deliveryData.notes}}
          </div>
        </template>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import WGList from '../../../../world/spa/components/WGList.vue';
import YbRegCard from '../components/customer/YbRegCard.vue';
import Anm22PayCard from '../components/Anm22PayCard.vue';

export default {
  components: {
    "vue-simple-spinner": Spinner,
    WGList,
    YbRegCard,
    Anm22PayCard
  },
  data() {
    return {
      loading: true,
      // Order
      order: null,
      elements: null,
      showCardModal: false,
      showStatusModal: false,
      // YB payment
      showYbModal: false,
      ybMode: 'select',
      ybRegs: {
        regs: [],
        active: false
      },
      selectedReg: null,
      // ANM22 Pay payment
      showPayModal: false,
      payCards: [],
      selectedPayCard: null,
      //Card payment
      showCardModal: false,
      cardLoading: false,
      paying: false,
      paymentError: false,
      usePaypal: false,
      //Stripe
      stripe: null,
      stripeClientSecret: null,
      stripeSelected: false,
      stripeCard: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline,
      appColor: state => state.config.appColor
    }),
    license() {
      if(this.licenseSelected) {
        return this.$store.getters["foodLicenses/getByHash"](
          this.licenseSelected
        );
      } else {
        return this.$store.getters["foodLicenses/getByHash"](
          this.order.license
        );
      }
    },
    employment() {
      return this.$store.getters['foodEmployments/get'](this.license.id + '-' + this.user.idWorldUser )
    },
    work() {
      return this.$store.getters['works/get'](this.license.work);
    },
    timezone() {
      return this.work.timezone;
    },
    table() {
      return this.order.tableRef ? this.$store.getters['foodTables/get'](this.order.tableRef) : null;
    },
    customer() {
      return this.order.customer 
          ? this.$store.getters['users/get'](this.order.customer) 
          : {
            idWorldUser: 0,
            name: this.$anm22.strLang(this.lang, 'Generic', 'Utente'),
            surname: this.$anm22.strLang(this.lang, 'user', 'generico'),
            image: null
          };
    },
    statusColor() {
      switch(this.order.status) {
        case 1:
          return '#FF6D00';
        case 2: 
          return '#BF360C';
        case 3:
          return '#FBC02D';
        case 4:
          return '#7CB342';
        case 5:
          return '#4FC3F7';
        case 6:
          return '#0091EA';
      }
    },
    // Order elements
    headerItems() {
      return [
        {
          field: 'name',
          label: this.$anm22.strLang(this.lang, 'Product', 'Prodotto'),
          class: 'wg-xs-6',
          disabled: false,
        },
        {
          field: 'unitPrice',
          label: this.$anm22.strLang(this.lang, 'Unit price', 'Prezzo unitario'),
          class: 'wg-xs-3 wg-sm-4',
          right: true,
          disabled: false,
        },
        {
          field: 'quantity',
          label: this.$anm22.strLang(this.lang, 'Amount', 'Quantità'),
          class: 'wg-xs-3 wg-sm-2',
          style: {justifyContent: 'flex-end'},
          disabled: false,
        }
      ]
    },
    tableItems() {
      const toPay = [];
      // const payed = [];
      // Da pagare
      let counter = 1;
      this.elements.forEach(e => {
        // if(!e.payment) {
        if(e.weight === "") {
          if(e.variations.length === 0) {
            const found = toPay.findIndex(
              row => row['list-metadata'].subtype === 'element'
                  && !row['list-metadata'].hasVariations
                  && row['list-metadata'].productId === e.product 
            );
            /* Se esiste aggiorno la riga altrimenti la creo e la aggiungo */
            if (-1 !== found) {
              toPay[found].quantity++;
            } else {
              toPay.push({
                id: counter++,
                name: e.productName,
                quantity: 1,
                unitPrice: e.price,
                'list-metadata': {
                  type: 'item',
                  subtype: 'element',
                  productId: e.product,
                  hasVariations: false,
                }
              });
            }
          } else {
            toPay.push({
              id: counter++,
              name: e.productName,
              quantity: 1,
              unitPrice: e.price,
              'list-metadata': {
                type: 'item',
                subtype: 'element',
                hasVariations: true
              }
            });
            // Push variations
            e.variations.forEach(v => {
              toPay.push({
                id: counter++,
                name: v.sign + ' ' + this.$anm22.food_getVariationName(this.lang, v),
                unitPrice: v.price,
                quantity: 0,
                'list-metadata': {
                  type: 'item',
                  subtype: 'variation'
                }
              });
            });
          }
        } else {
          const name = e.productName + ' ' + e.weight + ' ' + this.$anm22.tableClasses.foodUnitOfMeasurement().getById(e.productUom)['typeClassLiteral'];
          toPay.push({
            id: counter++,
            name: name,
            quantity: 1,
            unitPrice: e.price,
            'list-metadata': {
              type: 'item',
              subtype: 'element',
              hasVariations: e.variations.length > 0
            }
          });
          // Push variations
          e.variations.forEach(v => {
            toPay.push({
              id: counter++,
              name: v.sign + ' ' + this.$anm22.food_getVariationName(this.lang, v),
              unitPrice: v.price,
              quantity: 0,
              'list-metadata': {
                type: 'item',
                subtype: 'variation'
              }
            });
          });
        }
      });
      return toPay;
    },
    /* TOTALI */
    listTotal() {
      let result = 0;
      //Articoli + variazioni
      this.elements.filter(e => !e.payment).forEach(e => {
        result += e.price;
        e.variations.forEach(v => {
          result += v.price;
        });
      });
      // Coperti non contemplati nell'ordinazione da customer
      result += this.order.covers[0].length * this.order.covers[1];
      //Costo di consegna
      if (this.order.deliveryPrice) {
        result += this.order.deliveryPrice;
      }
      return this.$anm22.round(result, 2);
    },
    surcharge() {
      if(!this.order.payed) {
        const fixedSurcharge = this.license.paymentSurcharges[this.order.paymentMethod]['fixed'];
        const percentSurcharge = this.license.paymentSurcharges[this.order.paymentMethod]['percent'];
        return this.$anm22.round(fixedSurcharge + this.$anm22.round(this.listTotal / 100 * percentSurcharge, 2), 2);
      } else {
        return this.$anm22.round(this.order.surcharge, 2);
      }
    },
    // Nell'ordinazione da customer totalToPay è uguale a totalOrder
    totalOrder() {
      if(!this.order.payed) {
        return this.$anm22.round(this.listTotal + this.surcharge, 2);
      } else {
        return this.$anm22.round(this.order.payedTotal, 2);
      }
    },
    discount() {
      if(!this.order.payed) {
        return 0;
      } else {
        return this.$anm22.round(this.order.listTotal - this.order.payedTotal + this.order.surcharge, 2);
      }
    },
    totalVat() {
      if(!this.order.payed) {
        let result = 0;
        //Articoli + variazioni
        this.elements.filter(e => !e.payment).forEach(e => {
          result += e.price - (e.price / (1 + e.productVat / 100));
          e.variations.forEach(v => {
            result += v.price - (v.price / (1 + e.productVat / 100));
          });
        });
        // Coperti non contemplati nell'ordinazione da customer
        const coversTotal = this.order.covers[0].filter(c => !c).length * this.order.covers[1];
        result += coversTotal - (coversTotal / 1.1);
        //Costo di consegna
        if (this.order.deliveryPrice) {
          result += this.order.deliveryPrice - (this.order.deliveryPrice / 1.1);
        }
        result += this.surcharge - (this.surcharge / 1.1);
        return this.$anm22.round(result, 2);
      } else {
        return this.$anm22.round(this.order.totalVAT, 2);
      }
    }
  },
  methods: {
    openOrderEmployee() {
      const permission = this.employment.permission;
      const acs = this.$store.getters['foodAcs/get'](this.license.id + "-" + permission);
      if(acs && acs.fastCash) {
        this.$router.push('/fastCash/' + this.order.id).catch(e => console.log(e));
      } else {
        this.$router.push('/takeOrder/' + this.order.id).catch(e => console.log(e));
      }
    },
    openPaymentModal() {
      if(this.order.paymentMethod === 3) {
        this.openCardModal();
      } else if(this.order.paymentMethod === 7) {
        this.openYBModal();
      } else if(this.order.paymentMethod === 9) {
        this.openPayModal();
      }
    },
    // Pagamento con ANM22 Pay
    openPayModal() {
      this.showPayModal = true;
    },
    closePayModal() {
      this.showPayModal = false;
      this.selectedPayCard = null;
    },
    selectPayCard(card) {
      this.selectedPayCard = card.idWorldCard;
      this.order.paymentData = {
        cardId: card.idWorldCard
      };
    },
    async sendToPay() {
      const response = await this.$http.post('view-order/send-to-pay', {
        orderId: this.order.id,
        amount: this.totalOrder,
        paymentData: this.order.paymentData
      });
      if(!response.data.success) {
        // Messaggio di errore durante il pagamento
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Error during payment",
            "Errore durante il pagamento"
          ),
          type: "alarm"
        });
      } else {
        this.closePayModal();
        this.afterPay(response);
      }
    },
    // Pagamento con Stripe/Paypal
    showPaymentError(code) {
      this.paymentError = code;
      setTimeout(() => {
        this.paymentError = false;
      }, 5000);
    },
    closeCardModal() {
      this.showCardModal = false;
      this.cardLoading = false;
      this.paying = false;
      this.paymentError = false;
      this.stripeSelected = false;
      this.stripeClientSecret = null;
      this.stripeCard = null;
    },
    async openCardModal() {
      this.cardLoading = true;
      this.showCardModal = true;
      const description = this.work.name + ' - ' + this.$anm22.strLang(this.lang, 'Order #', 'Ordine #') + this.order.number;
      const amount = this.totalOrder;
      // get Stripe PaymentIntent and Paypal Order
      const payment_data = await this.$http.post('view-order/init-payment', {
        orderId: this.order.id,
        description,
        amount
      });
      this.$nextTick(() => {
        const vue = this;
        // Stripe setup
        if(payment_data.data.stripe) {
          this.stripeClientSecret = payment_data.data.stripe;
          const elements = this.stripe.elements();
          const cardStyle = {
            base: {
              color: '#32325d',
              fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#aab7c4'
              }
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          };
          // Setup card input
          const card = elements.create('card', {style: cardStyle});
          card.addEventListener('change', ({error}) => {
            const displayError = document.getElementById('stripe-card-errors');
            if (error) {
              displayError.textContent = error.message;
            } else {
              displayError.textContent = '';
            }
          });
          card.mount('#stripe-card');
          this.stripeCard = card;
          // Manage Stripe Card form
          const form = document.getElementById('stripe-card-form');
          form.addEventListener('submit', this.stripeCardSubmit);
          // Setup payment request button
          const paymentReq = this.stripe.paymentRequest({
            country: 'IT',
            currency: 'eur',
            total: {
              label: description,
              amount: Math.floor(amount * 100),
            },
            requestPayerName: true,
            requestPayerEmail: true,
          });
          const prButton = elements.create('paymentRequestButton', {
            paymentRequest: paymentReq,
            style: {
              height: 35
            }
          });
          // Check if can make payment before mounting
          paymentReq.canMakePayment().then(result => {
            if(result) {
              prButton.mount('#stripe-payment-request-button');
            }
          });
          // Listen on payment request to complete purchase
          paymentReq.on('paymentmethod', this.stripePRHandler);
        }
        // Paypal setup
        if(window.paypal && payment_data.data.paypal && typeof payment_data.data.paypal !== 'string') {
          window.paypal.Buttons({
            style: {
              // color: 'blue',
              height: 35
            },
            createOrder: function(data, actions) {
              return payment_data.data.paypal.result.id;
            },
            onApprove: async function(data, actions) {
              vue.paying = true;
              try {
                const response = await actions.order.capture().then(function(details) {
                  // alert('Transaction completed by ' + details.payer.name.given_name);
                  return vue.$http.post('view-order/paypal-confirm', {
                    paypalOrderId: data.orderID
                  });
                });
                if(response.data.success) {
                  vue.closeCardModal();
                  vue.afterPay(response);
                } else {
                  console.log(response.data.error);
                  vue.paying = false;
                  vue.showPaymentError(2);
                }
              } catch(e) {
                console.log(e);
                vue.paying = false;
                vue.showPaymentError(2);
              }
            },
            onError: function(err) {
              console.log(err);
              vue.paying = false;
              vue.showPaymentError(1);
            }
          }).render('#paypal-buttons-div');
        } else {
          console.log('Dati paypal non inizializzati.')
        }
        this.cardLoading = false;
      });
    },
    async stripeCardSubmit(event) {
      this.paying = true;
      event.preventDefault();
      const stripeData = {};
      // payment method
      stripeData.payment_method = {
        card: this.stripeCard
      };
      // shipping info
      if(this.order.deliveryType === 7) {
        stripeData.shipping = {
          name: this.order.deliveryData.name,
          address: {
            line1: this.order.deliveryData.street + ' ' + this.order.deliveryData.number,
            line2: this.order.deliveryData.line2,
            city: this.order.deliveryData.city,
            postal_code: this.order.deliveryData.zip,
            state: this.order.deliveryData.state,
            country: this.order.deliveryData.country
          }
        };
      }
      // receipt email
      stripeData.receipt_email = this.user.email;
      // Processing
      try {
        const result = await this.stripe.confirmCardPayment(this.stripeClientSecret,  stripeData);
        if(result.error) {
          console.log(result.error);
          this.paying = false;
        } else {
          this.stripeConfirm(result);
        }
      } catch(e) {
        console.log(e);
        // this.showPaymentError(1);
      }
    },
    async stripePRHandler(ev) {
      try {
        const confirmResult = await this.stripe.confirmCardPayment(
          this.stripeClientSecret,
          {payment_method: ev.paymentMethod.id},
          {handleActions: false}
        );
        if(confirmResult.error) {
          ev.complete('fail');
        } else {
          ev.complete('success');
          const result = await this.stripe.confirmCardPayment(this.stripeClientSecret);
          if(result.error) {
            console.log(result.error);
            // this.showPaymentError(1);
          } else {
            this.paying = true;
            this.stripeConfirm(result);
          }
        }
      } catch(e) {
        console.log(e);
        // this.showPaymentError(1);
      }
    },
    async stripeConfirm(result) {
      try {
        const response = await this.$http.post('view-order/stripe-confirm', {
          paymentIntent: result.paymentIntent
        });
        if(response.data.success) {
          this.closeCardModal();
          this.afterPay(response);
        } else {
          console.log(e);
          this.paying = false;
          this.showPaymentError(2);
        }
      } catch(e) {
        console.log(e);
        this.paying = false;
        this.showPaymentError(2);
      }
    },
    openYBModal() {
      if(this.ybRegs.active) {
        if(this.order.paymentData.beach) {
          this.sendToYB();
        } else {
          if(this.ybRegs.regs.length === 1) {
            this.selectYbReg(this.ybRegs.regs[0]);
          }
        }
        this.showYbModal = true;
      } else {
        // Ho selezionato pagamento YB ma non ci sono registrazioni attive
      }
    },
    selectYbReg(reg) {
      this.selectedReg = reg;
      this.order.paymentData = {
        beachId: this.selectedReg.beachFoodId,
        umbrella: this.selectedReg.umbrella,
        beachLicense: this.selectedReg.beachLicense,
        registration: this.selectedReg.id
      }
    },
    async sendToYB() {
      this.ybMode = 'pay';
      // const amount = this.$anm22.getOrderAmount(this, this.order);
      const response = await this.$http.post('view-order/send-to-yb', {
        orderId: this.order.id,
        amount: this.totalOrder,
        paymentData: this.order.paymentData
      });
      if(!response.data.success) {
        // Messaggio di errore durante il pagamento
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Error during payment",
            "Errore durante il pagamento"
          ),
          type: "alarm"
        });
      } else {
        this.showYbModal = false;
        this.ybMode = 'select';
        this.selectedReg = null;
        this.afterPay(response);
      }
    },
    async afterPay(response) {
      await Promise.all([
        this.$store.dispatch('foodOrders/update', {
          vlf: this.$vlf('foodOrders'), objs: response.data.orders
        }),
        this.$store.dispatch('foodOrderElements/update', {
          vlf: this.$vlf('foodOrderElements'), objs: response.data.orderElements
        }),
      ]);
      this.order = this.$store.getters['foodOrders/get'](this.$route.params.id);
      this.elements = this.$store.getters['foodOrderElements/getByOrder'](this.order.id);
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "Payment successful!",
          "Pagamento avvenuto con successo!"
        ),
        type: "confirm"
      });
    },
    getStatusLabelStyle(status) {
      switch(status) {
        case 1:
          return '#FF6D00';
        case 2: 
          return '#BF360C';
        case 3:
          return '#FBC02D';
        case 4:
          return '#7CB342';
        case 5:
          return '#4FC3F7';
        case 6:
          return '#0091EA';
      }
    },
    async changeStatus(status) {
      try {
        const response = await this.$http.post('orders/change-status', {
          orderId: this.order.id,
          status: status.typeClass
        });
        await this.$store.dispatch("foodOrders/update",{
          vlf: this.$vlf('foodOrders'), objs: response.data.orders
        });
      } catch(e) {
        this.order.status = status.typeClass;
        await this.$store.dispatch("foodOrders/update",{
          vlf: this.$vlf('foodOrders'), objs: [this.order]
        });
        // this.$anm22.saveSyncTuple(vue, "FoodOrder", "edit", this.editingOrder);
        await this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodOrder",
          _table: "foodOrders",
          mode: 'edit',
          type: 'obj',
          obj: this.order
        });
      } finally {
        this.order.status = status.typeClass;
        this.showStatusModal = false;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromPath = from.path;
      vm.$store.dispatch('headbar/setBackHref', vm.fromPath);
    })
  },
  async created() {
    if(!this.$route.params.id) {
      this.$router.push('/').catch(e => console.log(e));
      return;
    }
    document.title = this.$anm22.strLang(this.lang, "Order ", "Ordine ");
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, "Order ", "Ordine ")
    );
    try {
      // Carico l'ordine
      const response = await this.$http.get('view-order', {
        params: {
          orderId: this.$route.params.id
        }
      });
      await Promise.all([
        this.$store.dispatch("foodLicenses/update", {
            vlf: this.$vlf("foodLicenses"),
            objs: [response.data.license]
          }),
          this.$store.dispatch("foodCategories/update", {
            vlf: this.$vlf("foodCategories"),
            objs: response.data.categories
          }),
          this.$store.dispatch("foodProducts/update", {
            vlf: this.$vlf("foodProducts"),
            objs: response.data.products
          }),
          this.$store.dispatch("foodTables/update", {
            vlf: this.$vlf("foodTables"),
            objs: response.data.tables
          }),
          this.$store.dispatch("ybLicenses/update", {
            vlf: this.$vlf("ybLicenses"),
            objs: response.data.ybLicenses
          }),
          this.$store.dispatch("works/update", {
            vlf: this.$vlf("works"),
            objs: response.data.works
          }),
          this.$store.dispatch("users/update", {
            vlf: this.$vlf("users"),
            objs: response.data.users
          }),
          this.$store.dispatch("foodOrders/update", {
            vlf: this.$vlf("foodOrders"),
            objs: response.data.orders
          }),
          this.$store.dispatch("foodOrderElements/update", {
            vlf: this.$vlf("foodOrderElements"),
            objs: response.data.orderElements
          })
      ]);
      this.ybRegs = response.data.ybRegs;
      this.payCards = response.data.cards
          .map(card => {
            card.isExpired = false;
            if(card.expirationDate) {
              const expiration = this.$moment.tz(card.expirationDate,'X',this.timezone).endOf('day');
              const now = this.$moment.tz(this.timezone);
              if(now.isAfter(expiration)) {
                card.isExpired = true;
              }
            }
            // card.selected = false;
            // if(this.order.paymentMethod === 9 && this.order.paymentData.cardId === card.idWorldCard) {
            //   card.selected = true;
            // }
            return card;
          })
          .sort((a,b) => b.number - a.number);
      this.order = this.$store.getters['foodOrders/get'](this.$route.params.id);
      // change page title
      document.title = this.$anm22.strLang(this.lang, "Order ", "Ordine ") + this.order.number;
      this.$store.dispatch(
        "headbar/setHeadbarTitle",
        this.$anm22.strLang(this.lang, "Order ", "Ordine ") + this.order.number
      );
      // Load libraries only if not payed
      if(this.order) {
        this.elements = this.$store.getters['foodOrderElements/getByOrder'](this.order.id);
        if(!this.order.payed) {
          if(this.license.paypalMerchantId) {
            // Paypal script
            const clientId = this.license.paypalSandbox ? process.env.VUE_APP_PAYPAL_SB_CLIENT_ID : process.env.VUE_APP_PAYPAL_CLIENT_ID;
            this.$anm22.loadScript(
              'paypal_smart_buttons',
              'https://www.paypal.com/sdk/js?client-id='+clientId+'&currency=EUR&disable-funding=card,venmo,sepa,bancontact,eps,giropay,ideal,mybank,p24,sofort',
              () => {}
            );
          }
          if(this.license.stripeTest || this.license.stripeAccount) {
            const pk = this.license.stripeTest ? process.env.VUE_APP_STRIPE_TEST_PK : process.env.VUE_APP_STRIPE_LIVE_PK;
            const stripeAccount = this.license.stripeTest ? process.env.VUE_APP_STRIPE_TEST_ACCT_ID : this.license.stripeAccount;
            // Stripe script https://js.stripe.com/v3/
            this.$anm22.loadScript(
              'stripe',
              'https://js.stripe.com/v3/',
              () => {
                this.stripe = Stripe(pk, {
                  stripeAccount
                });
              }
            );
          }
          /* se l'ordine è stato appena inserito apro il modale di pagamento 
            oppure pago direttamente l'ordine a seconda del metodo di pagamento */
          if(this.$route.query && this.$route.query.new) {
            if(this.order.paymentMethod === 3 || this.order.paymentMethod === 7 || this.order.paymentMethod === 9) {
              this.openPaymentModal();
            }
            // Altrimenti l'ordine viene settato come pagato esplicitamente dal gestore dalla cassa rapida
          }
        }
        this.loading = false;
        this.$Progress.finish();
      } else {
        this.$router.push('/');
      }
    } catch (e) {
      console.log(e);
      // se offline ritorna alla home
      this.$router.push('/').catch(e => console.log(e));
    }
  }
}
</script>

<style lang="scss" scoped>
.item-row {
  border-bottom: 1px solid #ccc;
  padding: 5px 0;
}
.payed-label {
  margin-left: 10px;
  border: 2px solid #7CB342;
  color: #7CB342;
  border-radius: 4px;
  font-size: 18px;
  padding: 2px 4px;
}
#stripe-card {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  transition: box-shadow 150ms ease;
  &.StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }
  &.StripeElement--invalid {
    border-color: #fa755a;
  }
  &.StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
}
.stripe-submit {
  width: 100%;
  height: 35px;
  font-size: 16px;
  background-color: #32325d;
  cursor: pointer;
  color: #fff;
  
  &:hover {
    box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2);
  }
}
.status-selectable {
  padding: 2px;
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background-color: #eee;
  }
}
.status-change-selectable {
  padding: 5px 10px;
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background-color: #eee;
  }
}
</style>
